import { newWebAction } from "../../../../common/factory/action.factory";
import { newFlow } from "../../../../common/factory/flow.factory";
import { newScheduledTrigger } from "../../../../common/factory/trigger.factory";
import { addScripts } from "../../../../common/factory/script.factory";
import { addNewVariable } from "../../../../common/factory/variable.factory";
import { ActionRenderOptions } from "../../../../common/constants/core/action.constants";
import { createCondition } from "../../../../common/factory/condition.factory";
import { ConditionType } from "../../../../common/interfaces/flow/condition/ConditionType";
import { ComparisonOperator } from "../../../../common/interfaces/flow/condition/ComparisonOperator";
import { LogLevel } from "../../../../common/interfaces/logging/LogLevel";

export const createFlowInstance=(scheduleCron, flowName, flowDescription)=>{
    const flow = newFlow(flowName)
    flow.description = flowDescription
    flow.logLevel = LogLevel.VERBOSE
    flow.enabled = true
    flow.trigger = newScheduledTrigger(scheduleCron)
    flow.logRetention = 5
    return flow;
}
export const createFlowPayload = (flow,
    workspaceId, 
    importSourceId,
    importCredentialObject,
    customImport
    ) => {
    
    //console.log(customImport)
    const assetScripts = [{name:"workspaceId", code:"return \"" + workspaceId + "\";"},
    {name:"importSourceId", code:"return \"" + importSourceId + "\";"},
    {name:"_version", code:"return \"1\";"}]

    const importMapping = newWebAction(flow, "Update Import Mapping", null, ActionRenderOptions[0].value);
    importMapping.method = "PATCH"
    importMapping.body = customImport.importMappingConfig
    importMapping.url = "https://api.atlassian.com/jsm/assets/workspace/{{workspaceId}}/v1/importsource/{{importSourceId}}/mapping"
    importMapping.credentialsReference = importCredentialObject
    addScripts(importMapping,assetScripts)

    const checkStatus = newWebAction(flow, "Check Import Status", null, ActionRenderOptions[0].value);
    checkStatus.method = "GET"
    checkStatus.url = "https://api.atlassian.com/jsm/assets/workspace/{{workspaceId}}/v1/importsource/{{importSourceId}}/configstatus"
    addScripts(checkStatus,assetScripts)
    checkStatus.credentialsReference = importCredentialObject

    const cancelStucked = newWebAction(flow, "Cancel import if it has stuck.", checkStatus.id, ActionRenderOptions[0].value);
    cancelStucked.body = "{}"
    cancelStucked.url = "{{cancelUrl}}"
    cancelStucked.credentialsReference = importCredentialObject
    cancelStucked.method = "DELETE"
    addNewVariable(cancelStucked,"cancelUrl","$.links.cancel")
    const combinedCondition = createCondition(ConditionType.COMBINED_CONDITION)
    const dataCondition = createCondition(ConditionType.DATA_CONDITION, {jsonPath:"$.status",value:"RUNNING",opertor:ComparisonOperator.EQUALS})
    combinedCondition.conditions.push(dataCondition)
    cancelStucked.conditions = [combinedCondition]

    const startImport = newWebAction(flow, "Start Import", null, ActionRenderOptions[0].value);
    startImport.method = "POST"
    startImport.url = "https://api.atlassian.com/jsm/assets/workspace/{{workspaceId}}/v1/importsource/{{importSourceId}}/executions"
    startImport.credentialsReference = importCredentialObject
    addScripts(startImport,assetScripts)


    //Make two list of action and submit action
    let listOfChildActions = [];
    const listOfGetAction = customImport.customActionObjects.map(customObject => {
        customObject.fetchAction.parentId = startImport.id;
        customObject.childActions.forEach((childAction) => {
            listOfChildActions.push(childAction); // appending childAction object to listOfChildActions
        });
        return customObject.fetchAction;
    });
    
    
    const completeImport = newWebAction(flow, "Complete Import", startImport.id, ActionRenderOptions[0].value);
    completeImport.method = "POST"
    addNewVariable(completeImport,"submitResultsUrl","$.links.submitResults")
    completeImport.url = "{{submitResultsUrl}}"
    completeImport.credentialsReference = importCredentialObject
    completeImport.body = "{\n  \"completed\": true\n}"

    flow.actions = [importMapping,checkStatus,cancelStucked,startImport]
    flow.actions = [...flow.actions,...listOfGetAction,...listOfChildActions]
    flow.actions = [...flow.actions,completeImport]

    return flow
}